var exports = {
  "Gt": "ChannelOriginIcon.module__frame___TVZyeW",
  "z5": "ChannelOriginIcon.module__cutout___TVZyeW",
  "qS": "ChannelOriginIcon.module__badge___TVZyeW",
  "Nw": "ChannelOriginIcon.module__badgeHighlighted___TVZyeW",
  "rF": "ChannelOriginIcon.module__badgeIcon___TVZyeW",
  "YQ": "ChannelOriginIcon.module__fallbackIcon___TVZyeW",
  "tR": "ChannelOriginIcon.module__fallbackIconHighlighted___TVZyeW",
};

module.exports = exports;
